import { Routes } from '@angular/router';
import { UnAuthGuard } from 'core/guards/unauth.guard';
import { SITE_ROUTES } from 'shared/enums/routes.enum';

export const routes: Routes = [
    {
        path: 'app',
        loadChildren: () => import('./app-shell.routes')
            .then(m => m.APP_SHELL_ROUTES)
    },
    {
        path: 'auth',
        loadComponent: () => import('shared/components/layouts/auth-layout/auth-layout')
            .then(m => m.AuthLayout),
        children: [
            {
                path: '',
                loadChildren: () => import('./features/auth/auth.routes')
                    .then(m => m.AUTH_ROUTES)
            }
        ],
        canActivateChild: [UnAuthGuard]
    },
    {
        path: 'subscriptions',
        loadChildren: () => import('./features/subscriptions/subscriptions.routes')
            .then(m => m.SUBSCRIPTIONS_ROUTES)
    },
    {
        path: '**',
        redirectTo: SITE_ROUTES.LOGIN.replace('/', '')
    },
];
